function _object_without_properties(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = _object_without_properties_loose(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}
function _object_without_properties_loose(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}
import { jsx as _jsx } from "react/jsx-runtime";
export function LinkIcon(_0) {
    let { color = '#53576C' } = _0, props = _object_without_properties(_0, [
        "color"
    ]);
    var _props_width, _props_height;
    return /*#__PURE__*/ _jsx("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: (_props_width = props.width) !== null && _props_width !== void 0 ? _props_width : 24,
        height: (_props_height = props.height) !== null && _props_height !== void 0 ? _props_height : 24,
        viewBox: "0 0 24 24",
        fill: color,
        children: /*#__PURE__*/ _jsx("path", {
            d: "M10 17.5501L8.23002 19.2701C7.76589 19.7342 7.1364 19.995 6.48002 19.995C5.82364 19.995 5.19415 19.7342 4.73002 19.2701C4.26589 18.806 4.00515 18.1765 4.00515 17.5201C4.00515 16.8637 4.26589 16.2342 4.73002 15.7701L9.27002 11.2201C9.71563 10.773 10.316 10.5144 10.947 10.4976C11.578 10.4809 12.1913 10.7073 12.66 11.1301L12.78 11.2301C12.9696 11.4157 13.2253 11.5185 13.4906 11.5157C13.756 11.5128 14.0094 11.4047 14.195 11.2151C14.3807 11.0255 14.4834 10.7699 14.4806 10.5045C14.4778 10.2391 14.3696 9.98575 14.18 9.80009C14.1236 9.72712 14.0635 9.65703 14 9.59009C13.1464 8.84741 12.0424 8.45694 10.9116 8.49779C9.78082 8.53864 8.70785 9.00775 7.91002 9.81009L3.31002 14.3601C2.52838 15.2109 2.10564 16.3308 2.13009 17.4858C2.15455 18.6409 2.6243 19.7419 3.44125 20.5589C4.2582 21.3758 5.35918 21.8456 6.51427 21.87C7.66935 21.8945 8.78923 21.4717 9.64002 20.6901L11.37 19.0001C11.5408 18.8137 11.6347 18.5696 11.6328 18.3168C11.6309 18.064 11.5333 17.8214 11.3597 17.6376C11.1861 17.4539 10.9494 17.3427 10.6971 17.3264C10.4448 17.3102 10.1958 17.3901 10 17.5501ZM20.69 3.31009C19.8488 2.4741 18.711 2.00488 17.525 2.00488C16.339 2.00488 15.2012 2.4741 14.36 3.31009L12.63 5.00009C12.4592 5.18644 12.3653 5.43057 12.3672 5.68336C12.3691 5.93615 12.4667 6.17883 12.6403 6.36258C12.8139 6.54633 13.0507 6.65751 13.303 6.67375C13.5552 6.68998 13.8043 6.61007 14 6.45009L15.73 4.73009C16.1941 4.26597 16.8236 4.00522 17.48 4.00522C18.1364 4.00522 18.7659 4.26597 19.23 4.73009C19.6941 5.19422 19.9549 5.82372 19.9549 6.48009C19.9549 7.13647 19.6941 7.76596 19.23 8.23009L14.69 12.7801C14.2444 13.2272 13.644 13.4858 13.013 13.5026C12.382 13.5193 11.7687 13.2929 11.3 12.8701L11.18 12.7701C10.9904 12.5844 10.7348 12.4817 10.4694 12.4845C10.2041 12.4874 9.95067 12.5955 9.76502 12.7851C9.57937 12.9747 9.47665 13.2303 9.47946 13.4957C9.48228 13.7611 9.59039 14.0144 9.78002 14.2001C9.85266 14.2744 9.92945 14.3445 10.01 14.4101C10.8647 15.1505 11.9682 15.5395 13.0983 15.4987C14.2284 15.4579 15.301 14.9903 16.1 14.1901L20.65 9.64009C21.4913 8.80417 21.9678 7.66932 21.9753 6.48334C21.9828 5.29736 21.5207 4.15659 20.69 3.31009Z",
            fill: color
        })
    });
}
